export var FETCH_UPDATE_DATE_REQUEST = 'FETCH_UPDATE_DATE_REQUEST';
export var FETCH_UPDATE_DATE_SUCCESS = 'FETCH_UPDATE_DATE_SUCCESS';
export var FETCH_UPDATE_DATE_FAILURE = 'FETCH_UPDATE_DATE_FAILURE';